type ClerkEmailSource =
  | {
      primaryEmailAddress?: {
        emailAddress?: string | null
      } | null
      emailAddresses?: Array<{ emailAddress?: string | null }>
    }
  | null
  | undefined

export const getPrimaryClerkEmail = (user: ClerkEmailSource) => {
  const primaryEmail = user?.primaryEmailAddress?.emailAddress?.trim()
  if (primaryEmail) return primaryEmail

  return (
    user?.emailAddresses?.find((email) => email.emailAddress?.trim())?.emailAddress?.trim() ?? ""
  )
}

export const buildWorkspaceNameFromEmail = (email: string) => {
  const normalizedEmail = email.trim()
  const [localPart, domainPart] = normalizedEmail.split("@")
  const source = domainPart?.split(".")[0] || localPart || "Tint"
  const words = source
    .replace(/[^a-zA-Z0-9]+/g, " ")
    .split(" ")
    .map((word) => word.trim())
    .filter(Boolean)

  if (!words.length) return "Tint Workspace"

  return `${words
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
    .join(" ")} Workspace`
}
